import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as routeBound from '../../../route-bound'

import { Api } from './api.service'
import type { TypeParams } from './types'

/** Users of the current app, offered when granting access to the survey. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: user => user.id,
      name: ec.Name.Predefined.SpaceAssignableUser,
    })
  }
}
